module.exports = __webpack_public_path__ + "static/large-monitor-8927cf1ae04a00b84e5789262bfd0fea.png";